import { Loader2 } from "lucide-react"

export default function VideoLoading() {
  return (
    <div className="bg-secondary flex aspect-video w-full items-center justify-center rounded-sm">
      <Loader2 className="text-muted-foreground h-8 w-8 animate-spin" />
    </div>
  )
}
